import React from 'react';
import { Placeholder } from 'react-bootstrap';
import CardLayout from '../../../../../shared/components/card/CardLayout';

export function ContractListSkeleton({ count = 3 }: { count?: number }) {
    return (
        <Placeholder as="div" animation="glow" className="my-2" aria-hidden="true">
            {Array.from({ length: count }).map((_, i) => (
                <div key={i} className="d-flex align-items-center default-radius p-2 mb-2">
                    <Placeholder className="skeleton skeleton-avatar" />
                    <div className="ml-2 flex-grow-1">
                        <Placeholder xs={7} className="skeleton d-block" />
                        <Placeholder xs={4} className="skeleton d-block mt-1" />
                    </div>
                    <Placeholder className="skeleton skeleton-flag-rect mr-2" />
                    <Placeholder className="skeleton skeleton-chevron" />
                </div>
            ))}
        </Placeholder>
    );
}

export function ContractsOverviewCardSkeleton() {
    return (
        <CardLayout classCard="position-relative mb-2">
            <Placeholder as="div" animation="glow" aria-hidden="true">
                <Placeholder xs={8} className="skeleton d-block mb-3" />
                <Placeholder className="skeleton skeleton-input d-block mb-3" />
                <Placeholder className="skeleton skeleton-stats-box d-block" />
            </Placeholder>

            <ContractListSkeleton />

            <Placeholder as="div" animation="glow" aria-hidden="true">
                <Placeholder className="skeleton skeleton-input d-block mt-2" />
            </Placeholder>
        </CardLayout>
    );
}
